import { useLocation, useOutletContext } from "react-router-dom";
import PageTitle from "@/components/PageTitle";
import { JobsOutletContext } from "@/pages/_layouts/jobs/JobPostIndexLayout";
import ViewJobOutcome from "@/pages/_layouts/jobs/_components/ViewJobOutcome";
import JobOutcomeSkeleton from "@/pages/_layouts/jobs/_components/JobOutcomeSkeleton";

export default function JobPostOutcome() {
  const location = useLocation();
  const { data, loading, title, refetch } = useOutletContext<JobsOutletContext>();

  if (loading && !data?.jobPost) {
    return <JobOutcomeSkeleton />;
  }

  if (!data?.jobPost) return null;

  return (
    <>
      <PageTitle pattern={location.pathname} title={`${title} | Jobs | Job Post Outcome`} />
      <ViewJobOutcome jobPost={data.jobPost} refetch={refetch} />
    </>
  );
}
